import { IconButton } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import { useSettings } from 'contexts/Settings/Settings';
import NextLink from 'next/link';
import { useMemo } from 'react';
import * as setup from 'setup';
import { Container } from './Progress.styled';

export default function Progress() {
    const game = useGame();
    const page = usePage();
    const settings = useSettings();

    const items = useMemo<ProgressItem[]>(() => {
        return setup.lessonParents.map((lesson, index) => {
            const active = lesson === page.lessonParent;
            return {
                active,
                disabled: !!index && !game.history?.[`${lesson}-start`] && !settings.debugProgress,
                href: `/lessons/${setup.lessons[lesson] ? lesson : setup.lessonKeys[0]}`,
                label: active ? `Current lesson ${lesson}` : `Go to lesson ${lesson}`,
            };
        });
    }, [game.history, page.lessonParent, settings.debugProgress]);

    return (
        <Container aria-label="Lesson progress" data-testid="progress-nav" role="navigation">
            {items.map((item, index) => (
                <IconButton
                    aria-hidden={item.disabled}
                    aria-label={item.label}
                    component={NextLink}
                    data-testid={`progress-dot-${index}`}
                    disabled={item.disabled}
                    href={item.href}
                    key={index}
                    size="small"
                >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="7" cy="7" r="7" fill="#fff" />
                        {(item.active || !item.disabled) && (
                            <circle
                                cx="7"
                                cy="7"
                                r={item.active ? 4 : 7}
                                fill={item.disabled ? '#fff' : setup.colors.orange}
                            />
                        )}
                    </svg>
                </IconButton>
            ))}
        </Container>
    );
}
